import * as React from 'react';
import C from './constants';
import { CountryRegionData } from './data';

interface IRegionDropdownProps {
	country: string,
	value: string | number,
	name: string,
	id: string,
	classes: string,
	blankOptionLabel: string,
	showDefaultOption: boolean,
	defaultOptionLabel: string,
	onChange: (value, e) => any,
	onBlur: (e) => any,
	labelType: string,
	valueType: string,
	disabled: boolean,
	disableWhenEmpty: boolean,
	customOptions: string[],
	countryValueType: string
}

export class RegionDropdown extends React.Component<IRegionDropdownProps, any> {
	public static defaultProps: Partial<IRegionDropdownProps> = {
		country: '',
		value: '',
		name: 'rcrs-region',
		id: '',
		classes: '',
		blankOptionLabel: '-',
		showDefaultOption: true,
		defaultOptionLabel: 'Select Region',
		onChange: () => null,
		onBlur: () => null,
		countryValueType: C.DISPLAY_TYPE_FULL,
		labelType: C.DISPLAY_TYPE_FULL,
		valueType: C.DISPLAY_TYPE_FULL,
		disabled: false,
		disableWhenEmpty: false,
		customOptions: []
	}
	constructor(props) {
		super(props);
		this.state = {
			regions: this.getRegions(props.country)
		};
		this.getRegions = this.getRegions.bind(this);
	}

	public shouldComponentUpdate(nextProps) {
		return (nextProps.country !== this.props.country) || (nextProps.value !== this.props.value);
	}

	public componentWillReceiveProps(nextProps) {
		if (nextProps.country === this.props.country) {
			return;
		}

		const defaultRegions = this.getRegions(nextProps.country);

		this.setState({
			regions: [
				...defaultRegions,
				...this.getCustomOptions(defaultRegions)
			]
		});
	}

	public getCustomOptions(regions) {
		const { customOptions } = this.props;

		const duplicateRegions = this.getDuplicates(regions);

		if (duplicateRegions.length) {
			console.error('Error: Duplicate regions present: ' + duplicateRegions.toString() + '.\nThe above item(s) is/are already getting added to the region dropdown by the library.');
			return [];
		}

		return customOptions.map((option) => {
			if (option) {
				return { name: option, shortCode: option };
			}
			return null;
		});
	}

	public getDuplicates(regions) {
		const { customOptions, valueType } = this.props;
		const regionKey = valueType === C.DISPLAY_TYPE_FULL ? 'name' : 'shortCode';

		return regions.filter((region) => {
			return customOptions.indexOf(region[regionKey]) !== -1;
		}).map(region => region[regionKey]);
	}

	public getRegions(country) {
		if (!country) {
			return [];
		}

		const { countryValueType } = this.props;
		const searchIndex = (countryValueType === C.DISPLAY_TYPE_FULL) ? 'countryName' : 'countryShortCode';
		let regions: any = [];
		CountryRegionData.forEach((i) => {
			if (i[searchIndex] === country) {
				regions = i.regions;
			}
		});

		// this could happen if the user is managing the state of the region/country themselves and screws up passing
		// in a valid country
		if (!regions || regions.length === 0) {
			console.error('Error. Unknown country passed: ' + country + '. If you\'re passing a country shortcode, be sure to include countryValueType="short" on the RegionDropdown');
			return [];
		}
		return regions;
	}

	public getRegionList() {
		const { labelType, valueType } = this.props;
		return this.state.regions.map(({ name, shortCode }) => {
			const label = (labelType === C.DISPLAY_TYPE_FULL) ? name : shortCode;
			const value = (valueType === C.DISPLAY_TYPE_FULL) ? name : shortCode;
			return <option value={value} key={name}>{label}</option>;
		});
	}

	// there are two default options. The "blank" option which shows up when the user hasn't selected a country yet, and
	// a "default" option which shows
	public getDefaultOption() {
		const { blankOptionLabel, showDefaultOption, defaultOptionLabel, country } = this.props;
		if (!country) {
			return <option value="">{blankOptionLabel}</option>;
		}
		if (showDefaultOption) {
			return <option value="">{defaultOptionLabel}</option>;
		}
		return null;
	}

	public render() {
		const { value, country, onChange, onBlur, id, name, classes, disabled, blankOptionLabel, showDefaultOption,
			defaultOptionLabel, labelType, valueType, countryValueType, disableWhenEmpty, customOptions,
			...arbitraryProps } = this.props;

		const isDisabled = disabled || (disableWhenEmpty && country === '');
		const attrs: any = {
			...arbitraryProps,
			name,
			value,
			onChange: (e) => onChange(e.target.value, e),
			onBlur: (e) => onBlur(e),
			disabled: isDisabled
		};
		if (id) {
			attrs.id = id;
		}
		if (classes) {
			attrs.className = classes;
		}

		return (
			<select {...attrs}>
				{this.getDefaultOption()}
				{this.getRegionList()}
			</select>
		);
	}
}
